export default function () {
  return {
    transports: {},
    loading: false,
  }
}
